import { Box, Card, Typography } from "@mui/material";
import { HunterCardHeader } from "Components/Shared/Inputs/HunterList/HunterCardHeader";

type Props = {
  licenseNo: string;
  commission: number | string;
  hasError?: boolean;
  companyName?: string;
  isPrimary?: boolean;
};

export const LicenseShareCard = ({
  licenseNo,
  commission,
  companyName,
  hasError = false,
  isPrimary = false,
}: Props) => (
  <Card
    sx={({ palette }) => ({
      display: "flex",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: 2,
      py: 2,
      px: 3,
      fontWeight: 300,
      border: `1px solid ${hasError ? palette.error.main : palette.grey[300]}`,
    })}
  >
    <Box
      width="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <HunterCardHeader
        isPrimary={isPrimary}
        companyName={companyName}
        licenseNo={licenseNo}
      />
      <Typography
        variant="h6"
        fontSize="1.125rem"
        lineHeight={1}
        color={hasError ? "error" : "text.primary"}
        fontWeight={600}
      >
        {commission} %
      </Typography>
    </Box>
  </Card>
);
